module.exports = __webpack_public_path__ + "static/media/______ 033.dee4e453.jpg";